<template>
  <div id="app">
    <div v-if="changeIndex ==2">
      <div v-if="false" class="login">
        <div class="full">
          <div>
            <div id="componentContainer" class="full animation-container">
              <div>
                <div class="login-new-containers" style="display: block;">
                  <div class="login_maincont">
                    <div class="top-link">
                      <ul>
                        <li>
                          <b></b>
                          <a href="/" target="_blank">
                            <i class="icon ic-pc"></i>
                            <span>电脑客户端</span>
                          </a>
                        </li>
                        <li>
                          <a href="/" target="_blank">
                            <i class="icon ic-phone"></i>
                            <span>手机客户端</span>
                          </a>
                          <div class="phoneCode" style="display: none;">
                            <img src="/" />
                          </div>
                        </li>
                        <li>
                          <b class="new"></b>
                          <a href="javascript:;" target="_blank">
                            <i class="icon ic-hangUp"></i>
                            <span>新挂机软件</span>
                          </a>
                        </li>
                      </ul>
                      <div class="clearfix"></div>
                    </div>
                    <div class="clearfix"></div>
                    <div class="login_warp">
                      <div class="login_list">
                        <p class="link-kefu">
                          <a href="/" target="_blank">
                            <i></i>联系客服
                          </a>
                        </p>
                        <form
                          action="/index.php/user/logined"
                          method="post"
                          onajax="userBeforeLogin"
                          enter="true"
                          id="signupForm"
                          call="userLogin"
                          target="ajax"
                        >
                          <ul class="login_input">
                            <li class="inputbox">
                              <i class="icon ic-username"></i>
                              <input
                                name="username"
                                type="text"
                                class="input-username"
                                id="username"
                                maxlength="32"
                                placeholder="输入用户名"
                                style
                                v-model="userName"
                              />
                            </li>

                            <li class="inputbox" style="margin-top: -20px;">
                              <i class="icon ic-password"></i>
                              <input
                                name="password"
                                type="password"
                                class="input-password"
                                id="password"
                                maxlength="28"
                                placeholder="输入登录密码"
                                style
                                v-model="password"
                              />
                            </li>
                            <li class="yzmbox inputbox" style="margin-top: -20px;">
                              <i class="icon ic-username" style="background-position: -80px -35px;"></i>
                              <input
                                style="background-color: #fff;"
                                name="vcode"
                                type="text"
                                class="input-code"
                                id="vcode"
                                maxlength="4"
                                placeholder="验证码"
                                v-model="yzm"
                              />
                              <img
                                style="top: 7px;width: 100px;right: 10px;height: 35px;"
                                class="validate"
                                width="80"
                                height="25"
                                border="0"
                                id="dvcode"
                                :src="yzmImage"
                                title="点击刷新"
                                @click="yzmsx()"
                              />
                            </li>

                            <li
                              class="submit-input"
                              style="    margin-top: -25px;margin-left: -5px;"
                            >
                              <input
                                type="button"
                                class="submit-login"
                                value="会员登录"
                                @click="login()"
                              />
                            </li>
                          </ul>
                          <table border="0" cellspacing="0" cellpadding="0"></table>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div></div>
        </div>
      </div>
      <Login :yzmImage="yzmImage" @changeImage="yzmsx"  @login="login"/>
    </div>
    <div v-else-if="changeIndex ==3" class="changePassword">
      <div id="myWarpr">
        <table class="myLayer" cellspacing="0" cellpadding="0" border="0">
          <tbody>
            <tr>
              <td>
                <div class="myLayerOn" style="display: none;"></div>
                <div class="myLayerTitle">
                  <h3>首次登录密码变更</h3>
                  <a href="javascript:;" class="myLayerClose" title="關閉" @click="closeWin()"></a>
                </div>
                <div class="myLayerContent" style="width: 380px; height: auto; overflow-y: auto;">
                  <table width="100%" cellspacing="0" cellpadding="0" border="0">
                    <tbody>
                      <tr>
                        <td valign="top">
                          <table id="changepwd" class="infoList">
                            <tbody>
                              <tr>
                                <td height="30" width="100" align="right">原密码&nbsp;</td>
                                <td height="30">
                                  &nbsp;
                                  <input
                                    name="voldpassword"
                                    class="input"
                                    style="width:130px;"
                                    autocomplete="new-password"
                                    type="password"
                                    v-model="voldpassword"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td height="30" align="right">新密码&nbsp;</td>
                                <td height="30" align="left">
                                  &nbsp;
                                  <input
                                    name="vnewpassword"
                                    autocomplete="new-password"
                                    class="input"
                                    style="width:130px;"
                                    type="password"
                                    v-model="vnewpassword"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td height="30" align="right">确認密码&nbsp;</td>
                                <td height="30" align="left">
                                  &nbsp;
                                  <input
                                    name="vrenewpassword"
                                    autocomplete="new-password"
                                    class="input"
                                    style="width:130px;"
                                    type="password"
                                    v-model="vpnewpassword"
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div>
                    <span style="color:red;text-align:center">
                      系统提示：密码必须包含大写字母、小写字母、特殊符号 数字长度大于8位！
                    </span>
                  </div>
                </div>
                <div class="myLayerFooter" style="display: block;">
                  <a
                    href="javascript:;"
                    class="btn grayBtn myLayerCancel"
                    title="重置"
                    style="display: inline-block;"
                    @click="reset()"
                  >重置</a>
                  <a
                    href="javascript:;"
                    class="btn hotBtn myLayerOk"
                    title="确定修改"
                    style="display: inline-block;"
                    @click="sure()"
                  >确定修改</a>
                </div>
                <div class="myLayerLoading"></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-else-if="changeIndex ==4" class="">
      <userAgreement @sure="agree()"  @exit="exit()"/>
    </div>
    <div v-else-if="changeIndex ==5">
      <Home />
    </div>
  </div>
</template>

<script>
import "../assets/css/style.css";
import "../assets/css/vendors.css";
import "../assets/css/index.css";
import "../assets/css/reset.css"
import Home from "../components/home";
import Login from "../components/login"
import userAgreement from "../components/userAgreement"
import { logined, agreed, searchBtn, loginOper } from "../assets/js/base";
import { G } from "../assets/js/gamedefault";
import getData from "../components/getData/getData";
import { goLoginAfterPasswordChange, stopAllTimers } from "../assets/js/session";

export default {
  data() {
    return {
      yzmImage: "",
      changeIndex: 2,
      userName: "",
      username: "",
      password: "",
      userInfo: {},
      yzm: "",
      yzmId: "",
      voldpassword: "",
      vnewpassword: "",
      vpnewpassword: ""
    };
  },
  components: {
    Home,
    Login,
    userAgreement
  },
  mounted() {
    console.log("%c安全警告", "font-size: 38px; color:red;")
    console.log("%c此浏览器功能专供开发者使用。请不要在此粘贴执行任何内容，这可能会导致您的账户受到攻击，给您带来损失！", "font-size: 16px; color: gray;")
    console.log("%c如果您需要对接机器人请使用API对接效率更高更稳定。飞单机器人对接API文档下载地址：请联系上级", "font-size: 16px; color: gray;")

    $("body").addClass("Blue")
    if (!window.navigator.userAgent.includes("Window")) {
      if (this.changeIndex == 1) {
        $("body").css({
          "overflow-x": "unset",
          width: "100%",
          "min-height": "100vh"
        });
      }
    }
    let login = window.sessionStorage.getItem("login");
    if (login) {
      this.changeIndex = 5;
      $("body").css({
        overflow: "unset",
        "min-width": "1150px",
        "min-height": "100vh"
      });
    } else {
      this.changeIndex = 2;
      this.yzmsx();
    }
    logined();

    document.addEventListener("keydown", e => {
      if (e.keyCode == 13) {
        if (this.changeIndex == 1) {
          this.searchBtn();
        } else if (this.changeIndex == 2) {
          // this.login();
        }
      }
    });
  },
  methods: {
    yzmsx() {
      const _this = this;
      let data = {};
      data.token = "";
      getData.postAxiosMethod("auth/verifycode", data, res => {
        _this.yzmId = res.data.data.Signid;
        _this.yzmImage = res.data.data.img;
      });
    },
    exit() {
      document.title = "138导航";

      if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
          var i = document.createElement('iframe');
          // i.src = '/favicon.ico';
          i.style.display = 'none';
          i.onload = function() {
              setTimeout(function(){
                  i.remove();
              }, 9)
          }
          document.body.appendChild(i);
      }
      sessionStorage.clear()
      this.changeIndex = 1;
    },
    agree() {
      agreed();
      const _this = this;
      let obj = {};
      obj.access_token = this.userInfo.access_token;
      obj.uid = this.userInfo.uid;
      window.sessionStorage.setItem(
        "login",
        _this.userInfo.access_token + "&" + _this.userInfo.uid
      );
      this.changeIndex = 5;
      window.sessionStorage.setItem("centerGgIndex", "1");
      window.sessionStorage.setItem("bottomGgIndex", "1");
      $("body").css({
        overflow: "unset",
        "min-width": "1150px",
        "min-height": "100vh"
      });
    },
    login(params) {
      console.log(params)
      const _this = this;
      this.userName = params.username
      this.passWord = params.password
      this.yzm = params.yzm
      if (this.userName !== "" && this.passWord !== "" && this.yzm !== "") {
        loginOper();
        let obj = {};
        obj.username = this.userName;
        obj.password = this.passWord;
        obj.signid = this.yzmId;
        obj.verifycode = this.yzm;

        getData.postAxiosMethod("auth/login", obj, res => {
          if (res.data.code == -104) {
            // G.alert({
            //   content: res.data.msg,
            //   ok: function() {
            //     _this.userInfo = res.data.data;
            //     _this.changeIndex = 3;
            //     return true;
            //   },
            //   type: "1"
            // });
            G.alert({
              content: res.data.msg,
              ok: function() {
                 _this.userInfo = res.data.data;
            _this.changeIndex = 3;
                return true;
              },
              type: "1"
            });

          } else if (res.data.code == -105) {
            G.alert({
              content: res.data.msg,
              ok: function() {
                return true;
              },
              type: "1"
            });
            _this.yzmsx();
          } else {
            _this.userInfo = res.data.data;
            window.sessionStorage.setItem(
              "login",
              _this.userInfo.access_token + "&" + _this.userInfo.uid
            );
            this.changeIndex = 4;
          }
        });
      } else {
        this.loginFlag = false;
        G.alert({
          content: "请输入姓名或密码、验证码",
          ok: function() {
            return true;
          },
          type: "1"
        });
      }
    },
    closeWin() {
      G.alert({ content: "首次登录密码必须修改", ok: function () {
        return true;
      } });
      },
    reset() {
      this.vnewpassword = "";
      this.voldpassword = "";
      this.vpnewpassword = "";
    },
    sure() {
      if (this.voldpassword && this.vnewpassword == this.vpnewpassword) {
        let data = {};
        data.username = this.userName;
        data.password = this.voldpassword;
        data.newpwd = this.vnewpassword;

        getData.postAxiosMethod("newpwd", data, res => {
          if (res.data.code == -104) {
            alert(res.data.msg);
            this.changeIndex = 3;
          } else {
            stopAllTimers();
            G.alert({
              content: "修改成功，请重新登录。",
              ok: function() {
                goLoginAfterPasswordChange();
                return true;
              },
              type: "1"
            });
          }
        });
        this.yzmsx();
      } else {
        G.alert({
          content: "请输入密码或者新密码两次输入不一致",
          ok: function() {
            return true;
          },
          type: "1"
        });
      }
    }
  }
};
</script>

 <style >
body {
  min-height: 100vh;
  overflow-x: hidden;
  /* min-width: 1150px */
}
.yd {
  padding: 1px;
  background: #e6e6e6;
}
.xy {
  width: 100%;
  padding: 8% 0 0;
  height: 100vh;
  margin: 10% auto;
  padding: 0;
}
.changePassword .myLayer {
  position: absolute;
  left: 40%;
  top: 35%;
  border: 3px solid #267cb9;
  background: #fff;
  padding: 1px 0 1px 1px;
  z-index: 9999;
  border-radius: 3px;
  box-shadow: 0 2px 5px #000;
}
.changePassword .myLayerOn {
  position: absolute;
  width: 19px;
  height: 10px;
  line-height: 10px;
  font-size: 0;
  top: -10px;
  left: 5px;
  background: url(../assets/images/skin/Yellow/BoxBg1.png) -290px -91px no-repeat;
}
.changePassword .myLayerTitle {
  height: 30px;
  line-height: 30px;
  background: #e4ecfb;
  border-bottom: 1px solid #d0ddec;
  overflow: hidden;
  zoom: 1;
}
.changePassword .myLayerTitle h3 {
  float: left;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  padding-left: 25px;
  background: url(../assets/images/skin/Yellow/BoxBg1.png) -63px -152px no-repeat;
  font-family: Verdana, "宋体", Arial, Sans;
}
.changePassword .myLayerTitle a {
  float: right;
  width: 30px;
  height: 30px;
  background: url(../assets/images/skin/Yellow/BoxBg1.png) -61px -192px no-repeat;
}
.changePassword .myLayerFooter {
  background: #e4ecfb;
  border-top: 1px solid #d0ddec;
  text-align: right;
  padding: 5px;
}
.changePassword .myLayerFooter .btn {
  font-size: 12px;
  display: inline-block;
  padding: 4px 20px;
  border: none;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  cursor: pointer;
}
.changePassword .myLayerFooter .grayBtn {
  font-weight: bold;
  color: #343434;
  text-shadow: 0px 1px 0px #b9c8df;
  background: #afc8e6;
  background-image: -webkit-linear-gradient(to top, #9dbbde, #bfd3ed);
  background-image: linear-gradient(to top, #9dbbde, #bfd3ed);
  border-bottom: 1px solid #6e96c8;
}
.changePassword .myLayerFooter a {
  margin: 0 0 0 5px;
}
</style>
